<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="page-user-edit">
        <vs-alert
            color="danger"
            title="System Error"
            :active.sync="configs_empty"
        >
            <span
                >Something is wrong with the system. Contact your service provider for help.
            </span>
        </vs-alert>

        <vx-card v-if="configs_data">
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <vs-tabs
                    v-model="activeTab"
                    class="tab-action-btn-fill-conatiner"
                >
                    <vs-tab
                        label="E-Card Header"
                    >
                        <div class="tab-text">
                            <setting-edit-tab
                                class="mt-4"
                                :data="configs_data"
                            />
                        </div>
                    </vs-tab>
                    <vs-tab
                        label="E-Card Footer"
                    >
                        <div class="tab-text">
                            <setting-edit-footer-tab
                                class="mt-4"
                                :data="configs_data"
                            />
                        </div>
                    </vs-tab>
                </vs-tabs>
            </div>
        </vx-card>
    </div>
</template>

<script>
import SettingEditTab from "./SettingEditTab.vue";
import SettingEditFooterTab from "./SettingEditFooterTab.vue"

// Store Module
import moduleConfigManagement from "@/store/config-management/moduleConfigManagement.js";

export default {
    components: {
        SettingEditTab,
        SettingEditFooterTab
    },
    data() {
        return {
            configs_data: null,
            configs_empty: false,

            /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
            activeTab: 0,
        };
    },
    watch: {
        activeTab() {
            this.fetch_configs_data();
        },
    },
    methods: {
        fetch_configs_data() {
            this.$store
                .dispatch("configManagement/fetchConfigs")
                .then((res) => {
                    this.configs_data = res.data;
                })
                .catch((err) => {
                    if (err.response.status === 404) {
                        this.configs_empty = true;
                        return;
                    }
                    console.error(err);
                });
        },
    },
    created() {
        // Register Module configManagement Module
        if (!moduleConfigManagement.isRegistered) {
            this.$store.registerModule("configManagement", moduleConfigManagement);
            moduleConfigManagement.isRegistered = true;
        }
        this.fetch_configs_data();
    },
};
</script>
